import * as React from 'react'

export const Throw: React.FunctionComponent<{ err?: any }> = (
  err: any = 'Generic Error'
) => {
  throw err
}
